<template>
    <div class="hero" v-bind:style="{ backgroundImage: 'url(' + heroImage + ')' }">
        <div class="hero__inner">
            <div class="hero__textbox">
                <h1 class="hero__title" ref="ref1">Design and interior decoration. <br>Individual approach.</h1>
                <router-link to="/about" class="hero__cta" ref="ref2">Click to enter</router-link>
            </div>
        </div>

        <div class="hero__footer">
            <p>Copyright 2019 Dizajn i vizualizacija d.o.o. Čret 28, 10 000 Zagreb, Croatia</p>

            <ul>
                <li><router-link to="/privacy">Privacy policy</router-link></li>
                <li><router-link to="/cookie">Cookie policy</router-link></li>
            </ul>
        </div>
    </div>
</template>


<script>
import { TimelineLite, Back } from 'gsap'

    export default {
        data() {
            return {
                // heroImage: 'https://codetheweb.blog/assets/img/posts/full-image-hero/image.jpg'
                // heroImage: './assets/bg/hero.jpg',
                heroImage: require('@/assets/bg/hero.jpg')
            }
        },

        mounted() {
            const tl = new TimelineLite();
            const { ref1, ref2 } = this.$refs
                         
            tl.set(ref1, {autoAlpha: 0, scale: .5});
            tl.to(ref1, 2, {scale: 1, autoAlpha: 1});
        },

        methods: {
            animationOnEnterPage: function () {
                console.log('animationOnEnterPage');


            }
        }
    };
</script>


<style scoped lang="scss">
    @import "@/scss/modules/_hero.scss";
</style>